export default {
  title: 'Nieodebrane zamówienia',
  card_title: 'E-maile o nieodebranych zamówieniach',
  intro:
    'Jeśli nikt nie przyjmie zamówienia w ciągu {{minutes}} min, zostanie ono automatycznie odrzucone. Każda osoba z tej listy otrzyma wtedy e-mail z zamówieniem, aby ktoś mógł się z klientem skontaktować.',
  default: {
    owner: 'Właściciel restauracji',
    partner: 'Partner',
    owner_missing: 'Właściciel restauracji ({{email}}) nie otrzyma tych e-maili.',
    partner_missing: 'Domyślny adres partnera ({{email}}) nie otrzyma tych e-maili.',
  },
  empty: 'Nikt nie dowie się o nieodebranych zamówieniach. Dodaj co najmniej jeden adres e-mail, aby zapisać.',
  save_error: 'Nie udało się zapisać adresów e-mail. Sprawdź połączenie i spróbuj ponownie.',
  load_error: 'Nie udało się wczytać adresów e-mail. Sprawdź połączenie i spróbuj ponownie.',
  unavailable: 'E-maile o nieodebranych zamówieniach nie są dostępne dla tej restauracji.',
  buttons: {
    save: 'Zapisz',
    retry: 'Spróbuj ponownie',
  },
  toasts: {
    saved: 'Zapisano e-maile o nieodebranych zamówieniach',
  },
};
